import React from "react";
import "./ThumbsUp.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";

const ThumbsUp = () => {
  return <FontAwesomeIcon icon={faThumbsUp} className="thumbsUp" />;
};

export default ThumbsUp;



// WEBPACK FOOTER //
// ./src/components/ThumbsUp.jsx